import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

/** */
import GuestArea from './guest/guest';
import MemberArea from './member/member';
import Spinner from 'app/shared/spinners/spinner-50/spinner-50';
import { useQuery } from 'app/hooks/query';
import { useGuestService } from 'hooks/guest';
import { addDataToStore } from 'store/actions/user-data';

/** */

import 'rsuite/dist/rsuite.min.css';
import './app.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { UploadProvider } from 'contexts/uploads';

const getLoginStatus = createSelector(
  (state) => state.user_data,
  (user_data) => {
    const { _id, token } = user_data;
    return _id && token;
  }
);

function App() {
  const dispatch = useDispatch();
  const userIsLoggedIn = useSelector(getLoginStatus);
  const { refreshToken } = useGuestService();

  // A redirect from another app (e.g. an agency entering a managed org) lands
  // here with the org's session in the query string: ?t=<token>&user_id=&tenant_id=.
  // When no one is logged in, exchange those for a full session and log them in.
  const { t: token, user_id, tenant_id } = useQuery();
  const can_token_login = !userIsLoggedIn && !!token && !!user_id && !!tenant_id;
  const [is_authenticating, setIsAuthenticating] = useState(can_token_login);

  useEffect(() => {
    if (!can_token_login) return;

    refreshToken({ user_id, tenant_id }, { token })
      .then((payload) => {
        if (payload) dispatch(addDataToStore({ ...payload, logged_in_time: Date.now() }));
      })
      .finally(() => {
        setIsAuthenticating(false);
        // Drop the credentials from the URL so they aren't left in history.
        window.history.replaceState({}, document.title, window.location.pathname);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (is_authenticating) {
    return (
      <div
        className="app-wrapper"
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div className="app-wrapper">
      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={
              userIsLoggedIn ? (
                <UploadProvider>
                  <MemberArea />{' '}
                </UploadProvider>
              ) : (
                <GuestArea />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
